module.exports = __webpack_public_path__ + "static/media/6e4ccf04-3efc-0904-b84b-a487225179e4.ad8751fc.jpg";